module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-activity-detail"
  }, [_c('header', [_c('router-link', {
    attrs: {
      "to": _vm.toFeedbackPage
    }
  }, [_c('h3', {
    staticClass: "activity-title"
  }, [_vm._v(" " + _vm._s(_vm.activityDetail.title) + " ")])]), _vm._v(" "), _c('section', {
    staticClass: "basic-info"
  }, [(_vm.activityHasDuration) ? _c('p', {
    staticClass: "duration"
  }, [_vm._v(" " + _vm._s(_vm.activityDuration) + " ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v(" " + _vm._s(_vm.activityAddress) + " ")])])], 1), _vm._v(" "), _c('section', {
    staticClass: "sign-info"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.toFeedbackPage
    }
  }, [_c('p', {
    staticClass: "sign-up-count"
  }, [_vm._v("总报名人数 "), _c('span', {
    staticClass: "count"
  }, [_vm._v(" " + _vm._s(_vm.activityDetail.signed_up_user_count) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "sign-in-count"
  }, [_vm._v("签到人数 "), _c('span', {
    staticClass: "count"
  }, [_vm._v(" " + _vm._s(_vm.activityDetail.current_session_time_sign_in_count) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "session-time"
  }, [_vm._v(" " + _vm._s(_vm.activityDetail.current_session_time_sign_in.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "lxm-activity-detail__right-arrow"
  })])], 1), _vm._v(" "), _c('section', {
    staticClass: "qr-code-scan"
  }, [_c('div', {
    staticClass: "qr-code-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped qr-code-row"
  }, [_c('div', {
    staticClass: "control sign-up-code has-addons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signInCode),
      expression: "signInCode"
    }],
    ref: "input",
    staticClass: "input is-expanded",
    attrs: {
      "id": "sign-up-code-input",
      "type": "number",
      "placeholder": "请输入票号或手机号"
    },
    domProps: {
      "value": _vm._s(_vm.signInCode)
    },
    on: {
      "keyup": function($event) {
        _vm.submitGetSignUp()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signInCode = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canUseScanQrCode),
      expression: "canUseScanQrCode"
    }],
    staticClass: "button qr-code-scan-button",
    attrs: {
      "id": "qr-code-scan-button"
    },
    on: {
      "click": function($event) {
        _vm.scanQRCode()
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.canUseScanQrCode),
      expression: "!canUseScanQrCode"
    }],
    staticClass: "submit-button button is-info is-outlined is-rounded",
    attrs: {
      "id": "sign-up-code-submit"
    },
    on: {
      "click": function($event) {
        _vm.submitGetSignUp()
      }
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), (_vm.activitySignUp) ? _c('sign-up', {
    attrs: {
      "activityDetail": this.activityDetail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.qrcodeModalVisible) ? _c('qr-code-scanner', {
    on: {
      "scan-code-result": _vm.scanCodeResult
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "sign-up-code-label",
    attrs: {
      "for": "sign-up-code-input"
    }
  }, [_vm._v("\n          签到  "), _c('span', {
    staticClass: "scan-tips"
  }, [_vm._v("点击 "), _c('i', {
    staticClass: "scan-icon"
  }, [_vm._v("1")]), _vm._v(" 可以扫描二维码进行签到 ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35e5aa86", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35e5aa86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Activity/Detail.vue
// module id = 835
// module chunks = 0